import { render, staticRenderFns } from "./u-chip-flat-label.vue?vue&type=template&id=4eb481b2&scoped=true&"
import script from "./u-chip-flat-label.vue?vue&type=script&lang=js&"
export * from "./u-chip-flat-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb481b2",
  null
  
)

export default component.exports